<template>
    <div class="blue-grey darken-2 rounded">
      <v-row>
        <v-col cols="7">
          <span class="white--text text-h5 ml-2">{{ t.totalAllPlants }}</span>
        </v-col>
        <v-col cols="5" class="text-right">
          <span class="white--text text-h5  mr-2">{{total.toFixed(2)}} m3</span>
        </v-col>
      </v-row>
    </div>
</template>

<script>

import { betonT } from '@/snippets/betonLang'

export default {
  name: 'betontotal',
  props: ['total'],
  data () {
    return {
      msg: '',
      lang: {},
      langC: {},
      locMonths: [],
      locYears: [],
      saving: false,
      postNew: false
    }
  },
  mounted () {

  },
  methods: {


  },
  computed: {
    t () {
      return betonT(this.$store.state.language)
    }
  },
  watch: {

  },
  components: {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
